if (!customElements.get('language-pills')) {
  customElements.define(
    'language-pills',
    class LanguagePills extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onItemClick.bind(this));
      }

      onItemClick(event) {
        const item = event.target.closest('[data-value]');
        if (!item) return;
        event.preventDefault();
        const form = this.closest('form');
        const input = form && form.querySelector('input[name="locale_code"]');
        if (!form || !input || item.dataset.value === input.value) return;
        input.value = item.dataset.value;
        form.submit();
      }
    }
  );
}

if (!customElements.get('language-select-classic')) {
  customElements.define(
    'language-select-classic',
    class LanguageSelectClassic extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        this.select.addEventListener('change', this.onChange.bind(this));
      }

      onChange() {
        const form = this.closest('form');
        if (form) form.submit();
      }
    }
  );
}
